module.exports = __webpack_public_path__ + "static/0016-734c4327ec5d73ed45cb1dfc0f05dc6d.png";